import script from "./ReportComponenet1Number.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportComponenet1Number.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__